import {css} from 'emotion'
import { Colors } from './..'

export const CounterfeitStyle = css({
  marginBottom: '4rem',
  '.counterfeit': {
    '&-content': {
      maxWidth: 'calc(10/12 * 100%)',
      flexBasis: 'calc(10/12 * 100%)',
      marginLeft: 'calc(1/12 * 100%)',
    },
    '&-title': {
      color: Colors.red,
      fontSize: '3rem',
      marginBottom: '2rem',
      textTransform: 'uppercase',
      'svg': {
        verticalAlign: 'middle',
        fill: Colors.red,
      },
    },
    '&-subtitle': {
      fontSize: '2rem',
      textTransform: 'uppercase',
      fontWeight: 'bold',
      marginBottom: '2rem',
      '&:after': {
        content:"''",
        display: 'block',
        margin: '1rem 0',
        height: 4,
        width: 50,
        background: 'black',
      }
    },
    '&-bloc': {
      margin: '2rem 0',
      '@media (min-width: 1024px)': {
        margin: '4rem 0',
      },
      '.bloc': {
        '&-title': {
          fontSize: '1.125rem',
          textTransform: 'uppercase',
          fontWeight: 'bold',
          margin: '1rem 0',
        }
      },
     '.video-container': {
        margin: '2rem 0',
        '@media (min-width: 1024px)': {
          margin: '4rem 0',
        }
     }
    }
  }  
})

export const TheftStyle = css({
  
})


// WEBPACK FOOTER //
// ./src/styles/containers/alerts.js